import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';

export default class PaymentExportAllExportSearchParams extends SearchParamsBase {
  initialize() {
    this.Id = '';
    this.SelectedOfficeIds = [];
    this.YRMO = '';
    this.Manual = '';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'Id', label: 'Id', className: 'col-6', type: InputTypesEnum.Number },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Payment Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'YRMO', label: 'YRMO', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'Manual', label: 'Manual', className: 'col-6', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'PaymentExportAllExportSearchParams';
  static maxWidth = 1000;

  //---------------------------
}
